import { FC } from 'react'
import {
  CmsInfoAccordionSection as FaqSectionProps,
  InfoAccordionFormat,
} from '../Sections/InfoAccordion'
import { Panel, PanelItem, PanelLayout } from '../Panel'
import { IdentImageTitle } from '../IdentImageTitle'
import { Colour, SectionPaddingDefault } from '../constants'
import cx from 'classnames'
import styles from './styles.module.scss'
import { InfoAccordionItem } from '../Sections/InfoAccordion/InfoAccordionItem'
import { useBlogRichText } from '../Blog/hooks/useBlogRichText'
import { useIsBlogPage } from '../../hooks/useIsBlogPage'

export const FaqSection: FC<FaqSectionProps> = ({ fields }) => {
  const {
    items,
    title,
    titleIdentImage,
    sectionPaddingBottom,
    sectionPaddingTop,
    footerText,
    format = InfoAccordionFormat.FAQ,
  } = fields

  const isBlog = useIsBlogPage()

  const renderedFooterText = useBlogRichText(footerText)

  return (
    <Panel short layout={PanelLayout.full} colour={Colour.warmStone}>
      <PanelItem
        className={cx(
          styles.faqSection,
          styles[sectionPaddingTop || SectionPaddingDefault.TOP],
          styles[sectionPaddingBottom || SectionPaddingDefault.BOTTOM],
          { [styles.isBlog]: isBlog },
        )}
      >
        {titleIdentImage && title ? (
          <div className={styles.title}>
            <IdentImageTitle
              Tag="h4"
              image={titleIdentImage}
              title={title}
              imageAlignment="right"
            />
          </div>
        ) : (
          title && (
            <h4 className={cx(styles.title, styles.noIdentImage)}>{title}</h4>
          )
        )}
        {items && (
          <div className={styles.items}>
            {items.map(item => {
              return (
                <InfoAccordionItem
                  format={format}
                  {...item}
                  key={item.sys.id}
                />
              )
            })}
          </div>
        )}
        {footerText && (
          <div className={styles.footerText}>{renderedFooterText}</div>
        )}
      </PanelItem>
    </Panel>
  )
}
